<template>
  <div class="text-block pb-16 pt-6">
    <div class="mx-auto w-full max-w-screen-xl container">
      <VcTypography :tag="model.heading" class="mb-3 text-2xl normal-case">{{ model.title }}</VcTypography>
      <div v-if="contentValue" v-html-safe="contentValue" class="block-content text-lg"></div>
    </div>
  </div>
</template>

<script setup lang="ts">
import VcTypography from "@/ui-kit/components/atoms/typography/vc-typography.vue";
import { computed } from "vue";

export interface IProps {
  model: {
    heading: string;
    title: string;
    text: string | { html: string };
  };
}

const props = defineProps<IProps>();

const contentValue = computed(() => {
  return typeof props.model.text === "object" ? props.model.text?.html : props.model.text;
});
</script>

<style lang="scss">
.text-block {
  .block-content {
    h1,
    h2,
    h3,
    h4,
    h5,
    ol,
    ul,
    p {
      margin-top: 1.5rem;
    }
    ul,
    ol {
      margin-left: 10px;
    }
    ol {
      list-style: decimal inside;
    }
    ul {
      list-style: disc inside;
    }
    a {
      text-decoration: underline;
      @apply text-[color:var(--color-primary)];
    }
  }

  .text-button-custom a {
    @apply text-white no-underline;
  }
}

.primary-bg {
  .block-content {
    a {
      @apply text-white;
    }
    ol {
      list-style: auto;
      margin-top: 1.5rem;
      margin-left: 1.25rem;
    }
  }
}
</style>
